// WCAG 4.1.1 (AChecker "id must be unique") — CMS HTML can contain several inline <svg>s exported with the same
// internal ids (e.g. two logos both defining <clipPath id="clip-path">). Suffix every id inside each <svg> with that
// svg's index and rewrite its local references (url(#…) incl. quoted, href="#…") so the markup renders the same with unique ids.
// References across different <svg>s (shared sprites) are not expected in this CMS content.
export default function uniquifySvgIds(html, prefix = 'svg') {
	if (!html) return html;

	let index = 0;
	return html.replace(/<svg\b[\s\S]*?<\/svg>/gi, svg => {
		const suffix = `-${prefix}${index++}`;
		const ids = [...svg.matchAll(/\sid="([^"]+)"/g)].map(m => m[1]);

		return ids.reduce(
			(out, id) =>
				out
					.split(`id="${id}"`)
					.join(`id="${id}${suffix}"`)
					.split(`url(#${id})`)
					.join(`url(#${id}${suffix})`)
					.split(`url('#${id}')`)
					.join(`url('#${id}${suffix}')`)
					.split(`url("#${id}")`)
					.join(`url("#${id}${suffix}")`)
					.split(`href="#${id}"`)
					.join(`href="#${id}${suffix}"`),
			svg
		);
	});
}
